export const DELETE_USER = 'delete_user';
export const EDIT_USER = 'edit_user';
export const RESET_PASSWORD = 'admin/reset_password';